import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Criteria from './components/Criteria';
import AboutSection from './components/AboutSection';
import Process from './components/Process';
import DealStructure from './components/DealStructure';
import WhatSellersExpect from './components/WhatSellersExpect';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import CookiePolicy from './pages/CookiePolicy';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Criteria />
      <AboutSection />
      <Process />
      <DealStructure />
      <WhatSellersExpect />
      <FAQ />
      <Contact />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/cookies" element={<CookiePolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
